;(async () => {
  if (!customElements.get('collection-list-slider')) {
    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import('swiper')

    Swiper.use([Navigation, Pagination, Scrollbar, Autoplay])

    class CollectionListSlider extends HTMLElement {
      constructor() {
        super()
        this.swiperElement = this.querySelector('[data-swiper-collection-list]')
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 1.25,
          direction: 'horizontal',
          breakpoints: {
            768: {
              slidesPerView: 2.8,
            },
            1024: {
              slidesPerView: 4,
            },
          },
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options)
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            }
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update()
          })
        }
        this.init()
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
      }
    }

    window.CollectionListSlider = CollectionListSlider

    customElements.define('collection-list-slider', CollectionListSlider)
  }
})()
